import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_CAMPAIGNS_QUERY_KEY } from "./useListCampaigns";

export const useDeleteCampaign = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (id: string) =>
            client.fetchApi<{ success: boolean }, {}>({
                endpoint: `campaigns/admin/${id}`,
                method: 'DELETE',
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_CAMPAIGNS_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
